import { SectionCardItem } from './SectionCardItem';
export default SectionCardItem;
